<template>
  <div class="dashboard__connections">
    <div class="row" v-if="hasConnections">
      <div class="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-7 mix__chart mix__chart--mfg">
        <ChartCustom :chart-settings="chartConfig" :chart-height="height" :chart-width="width" :chart-donut-hole=".65" class="chart__mix"></ChartCustom>
      </div>
      <div class="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-5 mix__chart mix__chart--mfg h-center-align">
        <table class="pieTable">
          <tbody v-if="detailedConnections">
            <tr v-for="(connection, index) in detailedConnections" v-bind:key="index">
              <td class="chartColor">
                <div class="chartColor__box" v-bind:class="'chartColor__box--'+index">&nbsp;</div>
              </td>
              <td class="pieTable__key">{{ connection.type }}</td>
              <td class="pieTable__value">{{ connection.qty }}</td>
            </tr>
            <tr>
              <td></td>
              <td class="pieTable__key">Time (hrs)</td>
              <td class="pieTable__value">{{ duration }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col connections__no-data">
        <div class="connections__placeholder"><img src="/images/Connections.svg" /></div>
        <div class="connections__placeholder h-grey-bg h-border-left">No data</div>
      </div>
    </div>
  </div>
</template>


<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import ChartCustom from '../../general/ChartCustom.vue'

  export default {
    name: 'ConnectionsChart',
    components: {
      ChartCustom,
    },
    props: {
      width: {
        type: Number,
        default: 150,
      },
      height: {
        type: Number,
        default: 150,
      },
    },
    data() {
      return {
        defaultWidth: 150,
        defaultHeight: 150,
      }
    },
    mounted() {
      // Load initial view info.
      this.$store.dispatch('connections/getConnections');
    },
    computed: {
      ...mapGetters('connections', ['connections', 'duration']),
      chartConfig() {
        return {
          data: {
            columns: this.sanitizedConnections,
            colors: {
              phone_call              : '#5DA8FF',
              face_to_face            : '#19CD9E',
              email                   : '#5E3784',
              initial_prospect_meeting: '#F88900',
              project_tracker_review  : '#0F9800',
              other                   : '#E43B28',
            },
            type : 'donut',
            empty: { label: { text: 'No data available' }},
          },
          legend: { show: false, position: 'right' },
          tooltip: {
            format: { value: () => '' }
          }
        };
      },
      sanitizedConnections() {
        return lodash.chain(this.connections)
          .toPairs()
          .map((type) => ([
            lodash.chain(type[0]).lowerCase().startCase().value(),
            type[1],
          ])).value();
      },
      hasConnections() {
        return lodash.chain(this.connections).values().reduce((sum, connection) => sum + connection, 0).value() > 1;
      },
      detailedConnections() {
        return lodash.chain(this.connections)
          .toPairs()
          .map((type) => ({
            type: lodash.chain(type[0]).lowerCase().startCase().value(),
            qty: type[1],
          })).value();
      },
    },
  };
</script>

<style lang="scss" scoped>
.connections {
  @include e(no-data) {
    @include flex-row;
    margin-top: -40px;
    margin-left: -23px;
    margin-right: -23px;
    margin-bottom: -23px;
    min-height: 26.4em;
  }
  @include e(placeholder) {
    @include flex-column;
    flex: 1;
    justify-content: center;
    align-items: center;
    height: 26.4em;
  }
}

.chartColor {
  @include e(box) {
    width: 11px;
    height: 11px;
    border-radius: 100%;
    border: none;

    @include m(phone_call) {
      background: $color-connection--phone-call;
    }

    @include m(email) {
      background: $color-connection--email;
    }

    @include m(face_to_face) {
      background: $color-connection--face-to-face;
    }

    @include m(initial_prospect_meeting) {
      background: $color-connection--ipm;
    }

    @include m(project_tracker_review) {
      background: $color-connection--ptr;
    }

    @include m(other) {
      background: $color-connection--other;
    }
  }
}

.mix {
  @include e('chart') {
    h3 {
      font-weight: 600;
      font-size: em(20px);
    }
  }
}

.chart {
  @include e('wrapper') {
    padding: 15px 0px 15px 15px;

    h3 {
      font-family: $font-family--secondary;
      color: $east-bay;
      font-size: em(16px);
      margin-bottom: 18px;
    }
  }
}

.pieTable {
  width: 100%;

  @include e('header') {
    color: $dove-grey;
    font-weight: 600;
    font-size: em(14px);

    @include m('value') {
      text-align: right;
    }
  }

  @include e('key') {
    color: $dove-grey;
  }

  .pieTable__value {
    text-align: right;
    color: $dove-grey;
    font-weight: 600;
  }

  tbody {
    border-top: 1px solid $mystic;
  }

  tbody:before {
    content: '';
    display: block;
    height: 5px;
  }

  th {
    font-weight: 500;
    padding-bottom: 5px;
  }

  td {
    text-align: left;
    padding: 4px;
  }

  .chartColor {
    width: 22px;
  }
}
</style>
